// src/utils/onboardingUtils.js

/**
 * Parses query parameters from window.location.search (or provided search string).
 * Returns object of key-value pairs.
 */
export const getQueryParams = (searchString = typeof window !== 'undefined' ? window.location.search : '') => {
  const params = new URLSearchParams(searchString);
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
};

/**
 * Checks for 'code' query parameter and saves it to localStorage if present.
 * Returns the parsed code or stored code.
 */
export const parseAndStoreOnboardingCode = (searchString = typeof window !== 'undefined' ? window.location.search : '') => {
  const params = getQueryParams(searchString);
  if (params.code) {
    const uppercaseCode = params.code.trim().toUpperCase();
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('solosync_link_code', uppercaseCode);
    }
    return uppercaseCode;
  }
  return typeof localStorage !== 'undefined' ? (localStorage.getItem('solosync_link_code') || '') : '';
};

/**
 * Detects whether current environment is an in-app browser (WebView).
 */
export const isInAppBrowser = (userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '') => {
  const ua = userAgent || '';
  const inAppRegex = /WhatsApp|FBAV|Instagram|Line|MicroMessenger|FBAN|Twitter|Snapchat|FB_IAB/i;
  return inAppRegex.test(ua);
};

/**
 * Detects iOS device (iPhone, iPad, iPod).
 */
export const isIOS = (userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '') => {
  return /iPhone|iPad|iPod/i.test(userAgent || '');
};

/**
 * Checks if running as installed PWA (standalone).
 */
export const isStandalone = () => {
  if (typeof window === 'undefined') return false;
  return (typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;
};
